import { useState } from "react";
import { Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Test from "./pages/Test";
import BotDashboard from "./pages/BotDashboard";
import Announce from "./pages/Announce";
import BotPresence from "./pages/BotPresence";
import ProtectedRoute from "./components/ProtectedRoute";
import Requests from "./pages/Requests";
import Torrent from "./pages/Torrents";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import TomatePoivron from "./pages/TomatePoivron";
import SeasonPage from "./pages/SeasonPage";
import RecipePage from "./pages/RecipePage";
import RecipesList from "./pages/RecipeList";
import Quebec from "./pages/Quebec";
import Notes from "./pages/Notes";
import ChatPopup from "./components/Chat/ChatPopup";
import ChatAdmin from "./pages/ChatAdmin";
import AdminRoute from "./components/AdminRoute";
import MaintenancePage from "./pages/MaintenancePage";

export default function App() {
    const [dark, setDark] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleTheme = () => setDark(prev => !prev);
    const toggleMenu = () => {}; // si tu veux gérer un menu mobile plus tard

    return (
        <div className={dark ? "app dark" : "app"}>
            <Routes>
                <Route path="/" element={<Login />} />

                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <Dashboard
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>

                    }
                />

                <Route
                    path="/bot-dashboard"
                    element={
                        <ProtectedRoute>
                            <BotDashboard
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/announce"
                    element={
                        <ProtectedRoute>
                            <Announce
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/bot-presence"
                    element={
                        <ProtectedRoute>
                            <BotPresence
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/users"
                    element={
                        <ProtectedRoute>
                            <Users
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/requests"
                    element={
                        <ProtectedRoute>
                            <Requests
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/settings"
                    element={
                        <ProtectedRoute>
                            <Settings
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/profile/:id"
                    element={
                        <ProtectedRoute>
                            <Profile
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/torrents"
                    element={
                        <ProtectedRoute>
                            <Torrent
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/garden"
                    element={
                        <ProtectedRoute>
                            <TomatePoivron
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/season/:id"
                    element={
                        <ProtectedRoute>
                            <SeasonPage
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/recipe"
                    element={
                        <ProtectedRoute>
                            <RecipesList
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/recipe/:id"
                    element={
                        <ProtectedRoute>
                            <RecipePage
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/quebec"
                    element={
                        <ProtectedRoute>
                            <Quebec
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/quebec/notes"
                    element={
                        <ProtectedRoute>
                            <Notes
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                onToggleMenu={toggleMenu}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/maintenance"
                    element={
                        <MaintenancePage
                            dark={dark}
                            setDark={setDark}
                            onToggleTheme={toggleTheme}
                            onToggleMenu={toggleMenu}
                            sidebarOpen={sidebarOpen}
                            setSidebarOpen={setSidebarOpen}
                        />
                    }
                />

                <Route
                    path="/test"
                    element={
                        <Test
                            dark={dark}
                            setDark={setDark}
                            onToggleTheme={toggleTheme}
                            onToggleMenu={toggleMenu}
                        />
                    }
                />
                <Route
                    path="/chat-admin"
                    element={
                        <AdminRoute>
                            <ChatAdmin
                                dark={dark}
                                setDark={setDark}
                                onToggleTheme={toggleTheme}
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </AdminRoute>
                    }
                />
            </Routes>
            {/*<ChatPopup />*/}
        </div>
    );
}
